/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_StatusInputs */

const en_qk_status = /** @type {(inputs: Qk_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status or category`)
};

const de_qk_status = /** @type {(inputs: Qk_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status oder Kategorie`)
};

/**
* | output |
* | --- |
* | "Status or category" |
*
* @param {Qk_StatusInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_status = /** @type {((inputs?: Qk_StatusInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_StatusInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_status(inputs)
	return en_qk_status(inputs)
});